import ConnectedSliderRange from "components/screener/shared/ConnectedSliderRange";

export default function TagAlong() {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">Tag Along</h3>
        <span className="flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400">
          Selecione uma faixa de Tag Along.
        </span>
      </div>

      <div className="space-y-9">
        <ConnectedSliderRange
          attribute="tagAlong.commonStock"
          label="Ações ON"
          accessibilityLabels={["Tag Along mínimo das Ações Ordinárias", "Tag Along máximo das Ações Ordinárias"]}
        />

        <ConnectedSliderRange
          attribute="tagAlong.preferredStock"
          label="Ações PN"
          accessibilityLabels={["Tag Along mínimo das Ações Preferenciais", "Tag Along máximo das Ações Preferenciais"]}
        />
      </div>
    </div>
  );
}
